//@ts-check
import {Button, Dropdown, RadioButton} from '@/components/atoms'
import {useSelectComboCategories} from '@/hooks/productCombo/useSelectComboCategories'
import {Font} from 'pepsico-ds'
import {ComboProductTable} from './ComboProductTable'
import {ComboSubCategories} from './ComboSubCategories'

export const SelectComboCategories = () => {
  const {categoriesOptions, handleCategoryChange, selectedCategories} = useSelectComboCategories()

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Products</Font>
      <div className="flex items-center justify-between">
        <RadioButton items={['Category & Products']} reference="radio button" selected={true} />
        {/* <Toggle uiSchema={{label: 'Ignore SKU List'}} value={ignoreSkuList} updateValue={handleIgnoreSkuListToggle} /> */}
      </div>
      <div className="h-px bg-gray-600" />
      <Font headingLevel={5}>Select Categories to Include</Font>
      <div className="flex items-center justify-between">
        <Dropdown
          label="Display Category*"
          isJsonWrap={false}
          childList={categoriesOptions}
          updateValue={handleCategoryChange}
          value={selectedCategories}
          selection="multiple"
          hideMenuListOnSelection={false}
          placeholder={
            selectedCategories.length === 0
              ? 'Select Display Categories'
              : selectedCategories.map(category => category.displayText).join(', ')
          }
        />
        <Button
          uiSchema={{variant: 'secondary', title: 'Reset', size: 'medium'}}
          handleButton={() => handleCategoryChange([])}
        />
      </div>
      <ComboSubCategories />
      <ComboProductTable />
    </div>
  )
}
